import React, { Component } from "react";

class MessageConfirmations extends Component {
  constructor(props) {
    super(props);
    this.state = { details: [{ moment: 0 }] };
  }
  _MakeRemoteRequest = () => {
    fetch("/message/details/?moment=" + this.props.moment)
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        this.setState({ details: data });
      });
  };
  componentDidUpdate() {
    console.log("COMPONENT UPDATE CALLED: State:");
    console.log(this.state);
    console.log("Props: ");
    console.log(this.props.moment);
    if (
      (this.state.details === undefined && this.props.moment > 0) ||
      (this.state.details &&
        this.props.moment > 0 &&
        this.props.moment !== this.state.details[0].moment)
    ) {
      this._MakeRemoteRequest();
      console.log("Message confirmations updated " + this.props.moment);
    }
  }

  render() {
    if (this.state.details === undefined || !this.state.details.length > 0)
      return null;
    if (this.state.details[0].moment === 0 && this.props.moment > 0)
      this._MakeRemoteRequest();
    console.log("Rendering with user: ");
    console.log(this.state.details);

    return (
      <div>
        <table className="table table-striped table-sm">
          <thead className="thead-dark">
            <tr>
              <th>Pushtoken</th>
              <th>Name</th>
              <th>Displayed</th>
              <th>Confirmed</th>
              <th>Confirmation Location</th>
            </tr>
          </thead>
          <tbody>
            {this.state.details.map(user => {
              if (user.location !== undefined && user.location !== null) {
		console.log(user);
                var datestring = new Date(user.location.timestamp)
                  .toLocaleString();
              }
              if (user.received !== undefined && user.received > 0) {
                var datestringR = new Date(user.received)
                  .toLocaleString();
              }
              return (
                <tr>
                  <td>
                    {user.pushToken ? user.pushToken.substring(17, 41) : ""}{" "}
                  </td>
                  <td>{user.name} </td>
                  <td>
                    {user.received !== undefined && user.received > 0 ? (
                      <span class="badge badge-success">
                        OK{" " + datestringR}
                      </span>
                    ) : (
                      <span class="badge badge-secondary">No Info</span>
                    )}
                  </td>
                  <td>
                    {user.confirmed ? (
                      <span class="badge badge-success">
                        OK
                        {" " + user.location !== undefined
                          ? " "+datestring
                          : ""}
                      </span>
                    ) : (
                      <span class="badge badge-secondary">Not Confirmed</span>
                    )}{" "}
                  </td>
                  <td>
                    {user.location !== undefined && user.location !== null && (
                      <a
                        href={
                          "http://www.google.com/maps/place/" +
                          user.location.coords.latitude +
                          "," +
                          user.location.coords.longitude
                        }
                        target="_blank"
                      >
                        <span className="oi oi-target"></span>
                        {"Alt.: " + Math.floor(user.location.coords.altitude)}m,
                        {user.location.coords.latitude},
                        {user.location.coords.longitude}
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default MessageConfirmations;
